import { render, staticRenderFns } from "./numberControl.vue?vue&type=template&id=31ad7aca&scoped=true&"
import script from "./numberControl.vue?vue&type=script&lang=js&"
export * from "./numberControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad7aca",
  null
  
)

export default component.exports